import { BaseModel } from '../base.model';

export class Warehouse extends BaseModel {
  warehouseId: number;
  companyId: number;
  location: string;
  warehouseName: string;
}
